import type { WindowKey } from "owa-bizchat-types";
import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

/** Sets the Tasks Hub active/visible state for a window. */
export const setTasksHubActiveMutator: (windowKey: WindowKey, active: boolean) => void = mutatorAction("setTasksHubActive", (windowKey: WindowKey, active: boolean) => {
    getStore().tasksHubActiveStateByWindow.set(windowKey, active);
});
